(function() {
  const MOBILE_MAX_WIDTH = 989;

  class FloatingFilterController {
    constructor(section) {
      this.section = section;
      this.aside = section.querySelector('[data-floating-filter]');
      if (!this.aside) return;

      this.desktopSlot = section.querySelector('[data-filter-desktop-slot]');
      this.mobileAnchor = section.querySelector('[data-mobile-filter-anchor]');
      this.topSentinel = section.querySelector('[data-mobile-filter-top-sentinel]');
      this.bottomSentinel = section.querySelector('[data-mobile-filter-bottom-sentinel]');
      this.state = 'desktop';
      this.isMobile = false;
      this.topPassed = false;
      this.bottomVisible = false;
      this.destroyed = false;

      this.onResize = this.onResize.bind(this);
      this.onTopIntersect = this.onTopIntersect.bind(this);
      this.onBottomIntersect = this.onBottomIntersect.bind(this);

      window.addEventListener('resize', this.onResize);
      this.onResize();
    }

    destroy() {
      this.destroyed = true;
      window.removeEventListener('resize', this.onResize);
      this.teardownObservers();
      if (this.section && this.section.classList) {
        this.section.classList.remove('floating-filter-enabled', 'floating-filter-active');
        this.section.style.removeProperty('--floating-filter-height');
      }
      if (this.desktopSlot && this.aside && !this.desktopSlot.contains(this.aside)) {
        this.desktopSlot.appendChild(this.aside);
      }
    }

    onResize() {
      if (this.destroyed) return;
      const currentlyMobile = window.innerWidth <= MOBILE_MAX_WIDTH;
      if (currentlyMobile === this.isMobile) {
        // Still ensure observers exist when switching templates via AJAX
        if (currentlyMobile) this.ensureObservers();
        return;
      }
      this.isMobile = currentlyMobile;
      if (this.isMobile) {
        this.enableMobileMode();
      } else {
        this.disableMobileMode();
      }
    }

    enableMobileMode() {
      if (!this.aside || !this.mobileAnchor) return;
      this.section.classList.add('floating-filter-enabled');
      if (!this.mobileAnchor.previousElementSibling || this.mobileAnchor.previousElementSibling !== this.aside) {
        this.mobileAnchor.parentNode.insertBefore(this.aside, this.mobileAnchor);
      }
      this.ensureObservers();
      this.updateState();
    }

    disableMobileMode() {
      this.section.classList.remove('floating-filter-enabled', 'floating-filter-active');
      this.section.style.removeProperty('--floating-filter-height');
      this.topPassed = false;
      this.bottomVisible = false;
      this.setState('desktop');
      this.teardownObservers();
      if (this.desktopSlot && this.aside && this.desktopSlot !== this.aside.parentNode) {
        this.desktopSlot.appendChild(this.aside);
      }
    }

    ensureObservers() {
      if (this.topSentinel && !this.topObserver) {
        this.topObserver = new IntersectionObserver(this.onTopIntersect, {
          threshold: [0],
        });
        this.topObserver.observe(this.topSentinel);
      }
      if (this.bottomSentinel && !this.bottomObserver) {
        this.bottomObserver = new IntersectionObserver(this.onBottomIntersect, {
          threshold: 0,
        });
        this.bottomObserver.observe(this.bottomSentinel);
      }
    }

    teardownObservers() {
      if (this.topObserver) {
        this.topObserver.disconnect();
        this.topObserver = null;
      }
      if (this.bottomObserver) {
        this.bottomObserver.disconnect();
        this.bottomObserver = null;
      }
    }

    onTopIntersect(entries) {
      entries.forEach((entry) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.topPassed = passed;
      });
      this.updateState();
    }

    onBottomIntersect(entries) {
      entries.forEach((entry) => {
        this.bottomVisible = entry.isIntersecting;
      });
      this.updateState();
    }

    updateState() {
      if (!this.isMobile) return;
      if (!this.topPassed && !this.bottomVisible) {
        this.setState('anchored');
        return;
      }
      if (this.bottomVisible) {
        this.setState('anchored');
      } else {
        this.setState('floating');
      }
    }

    setState(nextState) {
      if (!this.aside) return;
      if (this.state === nextState) return;
      this.aside.classList.remove('floating-state-hidden', 'floating-state-floating', 'floating-state-anchored');

      switch (nextState) {
        case 'floating':
          this.section.classList.add('floating-filter-active');
          this.section.style.setProperty('--floating-filter-height', `${this.aside.offsetHeight}px`);
          this.aside.classList.add('floating-state-floating');
          break;
        case 'anchored':
          this.section.classList.remove('floating-filter-active');
          this.section.style.removeProperty('--floating-filter-height');
          this.aside.classList.add('floating-state-anchored');
          break;
        case 'hidden':
          this.section.classList.remove('floating-filter-active');
          this.section.style.removeProperty('--floating-filter-height');
          this.aside.classList.add('floating-state-hidden');
          break;
        case 'desktop':
        default:
          this.section.classList.remove('floating-filter-active');
          this.section.style.removeProperty('--floating-filter-height');
          break;
      }

      this.state = nextState;
    }
  }

  function initFloatingFilters() {
    document.querySelectorAll('[data-floating-filter-section]').forEach((section) => {
      if (section._floatingFilterController) {
        section._floatingFilterController.destroy();
      }
      section._floatingFilterController = new FloatingFilterController(section);
    });
  }

  document.addEventListener('DOMContentLoaded', initFloatingFilters);
  document.addEventListener('shopify:section:load', initFloatingFilters);
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target;
    if (section && section._floatingFilterController) {
      section._floatingFilterController.destroy();
      delete section._floatingFilterController;
    }
  });

  document.addEventListener('collection:filters-updated', initFloatingFilters);

  window.initCollectionFilterFloating = initFloatingFilters;
})();
